<template>
  <div>
    <!-- 内部确认 -->
    <el-dialog :title="$t('message.internalConfirmation')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="780px" center>
      <div class="content">
        <!-- *类型 -->
        <div class="row">
          <div class="label" style="line-height: 40px;">
            <span>*</span> {{ $t('message.type') }} :
          </div>
          <div class="val" style="line-height: 40px;">
            <el-radio v-model="datas.is_complain" :label="1">确认投诉</el-radio>
            <el-radio v-model="datas.is_complain" :label="0" @change="handleChange">非投诉</el-radio>
          </div>
        </div>
        <!-- *投诉类别： -->
        <div class="row">
          <div class="label" style="line-height: 40px;">
            <span>*</span> {{ $t('message.complaintType') }} :
          </div>
          <div class="val">
            <el-select v-model="datas.complaint_type" :placeholder="$t('message.complaintType')" filterable>
              <el-option v-for="item in $parent.complaintType" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <!-- 处理截图 -->
        <div class="row">
          <div class="label">
            <span>*</span> {{ $t('message.ProcessScreenshots') }} :
          </div>
          <div class="val">
            <el-upload class="upload-demo" :action="baseURL + '/api/common/uploadFile'" :before-upload="befoUpload"
              :on-success="successup" :on-preview="handlePictureCardPreview" :limit="8" :on-exceed="exceed"
              :on-remove="handleRemove" list-type="picture-card" accept=".jpg,.jpeg,.png" :file-list="fileList" drag>
              <i class="el-icon-plus"></i>
            </el-upload>
            <p>1、请添加投诉处理的完整截图</p>
            <p>2、共可上传8张图片</p>
            <p>3、只支持jpeg、jpg、png格式、单张最大5M</p>
          </div>
        </div>
        <!-- 处理思路 -->
        <div class="row">
          <div class="label">
            <span>*</span> {{ $t('message.handlingIdeas') }} :
          </div>
          <div class="val">
            <el-input type="textarea" v-model="datas.content" :placeholder="$t('message.handlingIdeas')"></el-input>
          </div>
        </div>
        <!-- *是否纳入考核 -->
        <div class="row">
          <div class="label" style="line-height: 40px;">
            <span>*</span> {{ $t('message.isIncludedInAssessment') }} :
          </div>
          <div class="val" style="line-height: 40px;">
            <!-- 是 -->
            <el-radio v-model="datas.performance_status" :label="1">{{ $t('message.are') }}</el-radio>
            <!-- 否 -->
            <el-radio v-model="datas.performance_status" :label="2">{{ $t('message.no') }}</el-radio>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.save") }}
        </el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="imgDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      imgDialogVisible: false,
      fileList: [],
      datas: {
        id: [],
        type: '',
        content: '',
        deal_images: [],
        complaint_type: '',
        is_complain: '',
        performance_status: '',
      },
    };
  },
  methods: {
    handleRemove(res, fileList) {
      this.fileList = fileList
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgDialogVisible = true;
    },
    // 图片上传成功事件
    successup(res, file, fileList) {
      this.fileList = fileList
      this.$forceUpdate()
    },
    // 最多四张
    exceed() {
      this.$alert('最多只能传8张图片', '提示', {
        confirmButtonText: '确定',
        center: true,
        callback: action => {
        }
      });
    },
    befoUpload(file) {
      const isJPG =
        ["image/jpeg", "image/png", "image/jpg"].indexOf(file.type) != -1;
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 5MB!');
      }
      if (!isJPG) {
        this.$message.error(this.$fanyi("请上传图片"));
        return isJPG && isLt5M;
      }
    },
    // 投诉类别改变时，判断是否是投诉
    handleChange() {
      if (this.datas.is_complain == 0) {
        this.datas.performance_status = 2
      }
    },
    // 保存
    save() {
      this.datas.deal_images = []
      this.fileList.forEach(item => {
        this.datas.deal_images.push(item.response.data)
      })
      let flag = this.datas.content != '' && this.datas.deal_images != false && this.datas.complaint_type != ''
      if (this.datas.is_complain && !flag) {
        return this.$message.error('确认投诉的情况下，投诉类别、处理截图、处理思路不能为空，请填写后再提交确认')
      } else if (!this.datas.is_complain && this.datas.content == '') {
        return this.$message.error('处理思路不能为空，请填写后再提交确认')
      }
      this.$api.siteConfiguration.toWaitJapanV4(this.datas).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$parent.clientListV4()
      })
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      line-height: 118px;
      margin-right: 20px;
      width: 105px;


      span {
        color: red;
      }
    }

    .val {
      flex: 3;

      p {
        margin-top: 20px;
      }
    }
  }

  .table {
    border: 1px solid #edeff4;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;
      border: 0;

      li {
        padding: 24px 0;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex15 {
      flex: 1.5;
    }
  }

}

/deep/ .el-upload-dragger {
  width: 118px;
  height: 118px;
  border: none;
}
</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>